import { useApiQuery } from '@/shared/hooks/useApi';
import { api } from '@/shared/services/api';

import { UserDetailData } from '../types/userTypes';

export const useUserDetail = (userUuid: string) => {
  const {
    data: userDetailResponse,
    isLoading,
    isError,
    error,
    refetch,
  } = useApiQuery(
    ['user', 'detail', userUuid],
    () => api.get<UserDetailData>(`/api/v1/user/detail/${userUuid}`),
    {
      enabled: !!userUuid,
    },
  );

  return {
    userDetail: userDetailResponse?.data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
